import { useCallback, useState } from 'react';

// Looks up an Indian 6-digit pincode via the public India Post API.
// Resolves to { city, district, state, country, area, areas } or null.
export async function lookupPincode(pin) {
  const code = String(pin || '').trim();
  if (!/^\d{6}$/.test(code)) return null;
  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${code}`);
    const json = await res.json();
    const entry = Array.isArray(json) ? json[0] : null;
    const offices = entry?.Status === 'Success' ? entry.PostOffice || [] : [];
    if (!offices.length) return null;
    const first = offices[0];
    return {
      city: first.Block && first.Block !== 'NA' ? first.Block : first.District,
      district: first.District,
      state: first.State,
      country: first.Country || 'India',
      area: first.Name,
      areas: offices.map((o) => o.Name),
    };
  } catch {
    return null;
  }
}

// Hook form: call onPincodeChange(value) from the pincode input's onChange.
// When 6 digits are entered, onResult(details) is called with the lookup result.
export default function usePincodeLookup(onResult) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onPincodeChange = useCallback(
    async (value) => {
      setError('');
      if (!/^\d{6}$/.test(String(value || '').trim())) return;
      setLoading(true);
      const details = await lookupPincode(value);
      setLoading(false);
      if (details) onResult?.(details);
      else setError('Pincode not found');
    },
    [onResult]
  );

  return { onPincodeChange, loading, error };
}
